"use strict";

exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/dom-helpers/style/removeStyle.js
 ** module id = ./node_modules/react-bootstrap/node_modules/dom-helpers/style/removeStyle.js
 ** module chunks = 0
 **/